import apiWithAuth from './apiWithAuth';

const ADMIN_V1 = '/v1/admin';

export function listFieldBoys(params) {
  return apiWithAuth.get(`${ADMIN_V1}/field-ops/field-boys`, { params });
}

export function getFieldBoyStats(id) {
  return apiWithAuth.get(`${ADMIN_V1}/field-ops/field-boy/${id}/stats`);
}

export function assignShopsToFieldBoy(body) {
  return apiWithAuth.post(`${ADMIN_V1}/field-ops/assign-shop`, body);
}

export function reassignShop(body) {
  return apiWithAuth.patch(`${ADMIN_V1}/field-ops/reassign-shop`, body);
}

export function listVisits(params) {
  return apiWithAuth.get(`${ADMIN_V1}/field-ops/visits`, { params });
}

export function assignTicket(body) {
  return apiWithAuth.patch(`${ADMIN_V1}/field-ops/assign-ticket`, body);
}

export function listFieldIssues(params) {
  return apiWithAuth.get(`${ADMIN_V1}/field-ops/issues`, { params });
}

export function createFieldTask(body) {
  return apiWithAuth.post(`${ADMIN_V1}/field-tasks`, body);
}

export function listFieldTasks(params) {
  return apiWithAuth.get(`${ADMIN_V1}/field-tasks`, { params });
}

export function patchFieldTask(taskId, body) {
  return apiWithAuth.patch(`${ADMIN_V1}/field-tasks/${taskId}`, body);
}

export function searchShopsForPicker(params) {
  return apiWithAuth.get('/admin-panel/shops', { params });
}

/** Single shop detail for resolving picked shop label */
export function getAdminShop(shopId) {
  return apiWithAuth.get(`/admin-panel/shops/${shopId}`);
}
